<div class="flex-1 overflow-auto min-h-0">
  <table class="w-full text-sm border-collapse">
    <thead class="sticky top-0 z-10 bg-surface-100">
      <tr class="h-14">
        @for (col of columns(); track col.key) {
          <th
            class="text-left px-6 py-3 text-xs font-semibold text-navy-600 tracking-wider whitespace-nowrap"
            [class]="col.headerClass ?? ''"
            [class.cursor-pointer]="col.sortKey"
            [class.select-none]="col.sortKey"
            (click)="onSort(col)"
          >
            <div class="flex items-center gap-1">
              {{ col.header }}
              @if (col.sortKey) {
                <img
                  src="/icons/chevron-down-icon.svg"
                  class="w-3 h-3 transition-transform"
                  [ngClass]="{
                    'opacity-25': sortBy() !== col.sortKey,
                    '-rotate-180': sortBy() === col.sortKey && sortDirection() === 'asc',
                  }"
                  alt=""
                />
              }
            </div>
          </th>
        }
        <th class="w-16 px-4 py-3"></th>
      </tr>
    </thead>
    <tbody>
      @if (loading()) {
        @for (i of [1, 2, 3, 4, 5, 6, 7]; track i) {
          <tr class="border-b border-surface-100">
            @for (col of columns(); track col.key) {
              <td class="px-6 py-4">
                <div
                  class="h-3.5 rounded-full bg-surface-200 animate-pulse"
                  [style.width]="'60%'"
                ></div>
              </td>
            }
            <td class="px-4 py-4 w-16"></td>
          </tr>
        }
      } @else {
        @for (row of paginatedRows(); track $index) {
          <tr
            class="border-b border-surface-100 hover:bg-surface-50 group transition-colors"
            [class.cursor-pointer]="clickableRows()"
            [style.animation]="'table-row-in 0.22s ease-out both'"
            [style.animation-delay]="$index * 28 + 'ms'"
            (click)="clickableRows() && rowAction.emit(row)"
          >
            @for (col of columns(); track col.key) {
              <td class="px-6 py-4 text-xs" [class]="col.cellClass ?? ''">
                @if (col.cellTemplate) {
                  <ng-container
                    [ngTemplateOutlet]="col.cellTemplate"
                    [ngTemplateOutletContext]="{ $implicit: row }"
                  />
                } @else {
                  {{ col.cell?.(row) }}
                }
              </td>
            }
            <td class="px-4 py-4 text-right">
              <div
                class="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity"
              >
                @if (!clickableRows()) {
                  <button
                    (click)="rowDelete.emit(row); $event.stopPropagation()"
                    class="w-8 h-8 rounded-full hover:bg-red-50 flex items-center justify-center cursor-pointer transition-colors"
                    title="Delete"
                  >
                    <img src="/icons/trash-icon.svg" class="w-4 h-4" alt="Delete" />
                  </button>
                }
                <button
                  (click)="rowAction.emit(row); $event.stopPropagation()"
                  class="w-8 h-8 rounded-full bg-primary-600 text-white flex items-center justify-center cursor-pointer"
                  title="Edit"
                >
                  <img src="/icons/arrow-right-white-icon.svg" alt="Edit" />
                </button>
              </div>
            </td>
          </tr>
        } @empty {
          <tr>
            <td
              [attr.colspan]="columns().length + 1"
              class="px-6 py-16 text-center text-slate-400 text-sm"
            >
              No results found.
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>

@if (effectiveTotalPages() > 1) {
  <div class="flex items-center justify-end gap-1 px-4 py-3 shrink-0 border-t border-surface-100">
    <button
      (click)="goToPage(1)"
      [attr.disabled]="effectivePage() === 1 ? true : null"
      class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-surface-200 disabled:bg-surface-400-alpha disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer border border-surface-300"
    >
      <img src="/icons/chevron-first-icon.svg" class="w-3.5 h-3.5" alt="" />
    </button>

    <button
      (click)="goToPage(effectivePage() - 1)"
      [attr.disabled]="effectivePage() === 1 ? true : null"
      class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-surface-200 disabled:bg-surface-400-alpha disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer border border-surface-300"
    >
      <img src="/icons/chevron-left-icon.svg" class="w-3.5 h-3.5" alt="" />
    </button>

    @for (page of visiblePages(); track page) {
      <button
        (click)="goToPage(page)"
        [class]="
          page === effectivePage()
            ? 'bg-accent-500 text-white'
            : 'text-navy-600 hover:bg-surface-200 border border-surface-300'
        "
        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs font-medium transition-colors cursor-pointer"
      >
        {{ page }}
      </button>
    }

    <button
      (click)="goToPage(effectivePage() + 1)"
      [attr.disabled]="effectivePage() === effectiveTotalPages() ? true : null"
      class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-surface-200 disabled:bg-surface-400-alpha disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer border border-surface-300"
    >
      <img src="/icons/chevron-right-icon.svg" class="w-3.5 h-3.5" alt="" />
    </button>

    <button
      (click)="goToPage(effectiveTotalPages())"
      [attr.disabled]="effectivePage() === effectiveTotalPages() ? true : null"
      class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-surface-200 disabled:bg-surface-400-alpha disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer border border-surface-300"
    >
      <img src="/icons/chevron-last-icon.svg" class="w-3.5 h-3.5" alt="" />
    </button>
  </div>
}
